import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://wfshare.wishfin.com/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Check if user is already logged in
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    console.log('[DEBUG] AuthContext init: storedUser in localStorage =', storedUser);
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      console.log('[DEBUG] AuthContext init: restoring user, role =', parsed.role);
      setUser(parsed);
    }
    setLoading(false);
  }, []);

  // Login function
  const login = async (email, password) => {
    try {
      setLoading(true);
      setError('');

      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);

      console.log('[DEBUG] login: API_URL =', API_URL, 'email =', email);

      const response = await axios.post(
        `${API_URL}/login`,
        formData,
        {
          headers: {
            'x-api-key': API_KEY
          }
        }
      );

      const userData = response.data;
      console.log('[DEBUG] login: response from backend =', userData);

      // Guard against a misconfigured REACT_APP_API_URL causing the request
      // to hit the SPA's own routing (e.g. this app's own /login page) and
      // get back index.html instead of JSON from the API.
      if (!userData || typeof userData !== 'object' || !userData.role) {
        throw new Error(
          `Backend did not return a valid user object (got: ${typeof userData === 'string' ? userData.slice(0, 60) + '...' : JSON.stringify(userData)}). ` +
          `Check that REACT_APP_API_URL ("${API_URL}") points at the API, not the frontend itself.`
        );
      }

      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));

      return userData;
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Login failed';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  
  // Logout function
  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };
  
  const value = {
    user,
    isAuthenticated: !!user,
    loading,
    error,
    login,
    logout
  };
  
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
